<svg xmlns:dc="http://purl.org/dc/elements/1.1/" xmlns:cc="http://creativecommons.org/ns#" xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#"
  xmlns:svg="http://www.w3.org/2000/svg" xmlns="http://www.w3.org/2000/svg" xmlns:sodipodi="http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd"
  xmlns:inkscape="http://www.inkscape.org/namespaces/inkscape" version="1.1" x="0px" y="0px" width="117.81" height="52.928001"
  viewBox="0 0 117.80999 52.928" enable-background="new 0 0 595.28 841.89" xml:space="preserve" id="svg3791" sodipodi:docname="bennes.svg"
  inkscape:version="0.92.2 (5c3e80d, 2017-08-06)">
  <!--metadata id="metadata3797">
    <rdf:RDF>
      <cc:Work rdf:about="">
        <dc:format>image/svg+xml</dc:format>
        <dc:type rdf:resource="http://purl.org/dc/dcmitype/StillImage" />
      </cc:Work>
    </rdf:RDF>
  </metadata-->
  <defs id="defs3795" />
  <!--sodipodi:namedview pagecolor="#ffffff" bordercolor="#666666" borderopacity="1" objecttolerance="10" gridtolerance="10"
    guidetolerance="10" inkscape:pageopacity="0" inkscape:pageshadow="2" inkscape:window-width="1920" inkscape:window-height="1017"
    id="namedview3793" showgrid="false" inkscape:zoom="0.4665165" inkscape:cx="290.88421" inkscape:cy="-361.72873" inkscape:window-x="-8"
    inkscape:window-y="-8" inkscape:window-maximized="1" inkscape:current-layer="svg3791" /-->
  <g id="Calque_1" display="none" style="display:none" transform="translate(-6.7558,-6.28828)">
    <g display="inline" id="g3777" style="display:inline">
      <g id="g3751">
        <rect x="264.99899" y="393.42401" width="67.040001" height="88.486" id="rect3749" style="fill:#ffffff" />
      </g>
      <g id="g3755">
        <rect x="265.08801" y="393.42401" width="14.475" height="88.486" id="rect3753" style="fill:#5c92cd" [ngStyle]="{'fill': lightcolor}"
        />
      </g>
      <g id="g3759">
        <rect x="318.54001" y="393.42401" width="14.458" height="88.486" id="rect3757" style="fill:#5c92cd" [ngStyle]="{'fill': lightcolor}"
        />
      </g>
      <g id="g3763">
        <path d="m 335.732,394.277 h -74.469 c -1.451,0 -2.628,-1.172 -2.628,-2.617 0,-1.456 1.178,-2.628 2.628,-2.628 h 74.469 c 1.445,0 2.629,1.172 2.629,2.628 0,1.444 -1.183,2.617 -2.629,2.617 z"
          id="path3761" inkscape:connector-curvature="0" style="fill:#284566" [ngStyle]="{'fill': darkcolor}" />
      </g>
      <g id="g3767">
        <path d="m 335.732,418.302 h -74.469 c -1.451,0 -2.628,-1.172 -2.628,-2.628 0,-1.457 1.178,-2.629 2.628,-2.629 h 74.469 c 1.445,0 2.629,1.172 2.629,2.629 0,1.455 -1.183,2.628 -2.629,2.628 z"
          id="path3765" inkscape:connector-curvature="0" style="fill:#284566" [ngStyle]="{'fill': darkcolor}" />
      </g>
      <g id="g3771">
        <path d="m 335.732,463.297 h -74.469 c -1.451,0 -2.628,-1.184 -2.628,-2.629 0,-1.457 1.178,-2.629 2.628,-2.629 h 74.469 c 1.445,0 2.629,1.172 2.629,2.629 0,1.445 -1.183,2.629 -2.629,2.629 z"
          id="path3769" inkscape:connector-curvature="0" style="fill:#284566" [ngStyle]="{'fill': darkcolor}" />
      </g>
      <g id="g3775">
        <path d="m 335.732,484.551 h -74.469 c -1.451,0 -2.628,-1.172 -2.628,-2.641 0,-1.443 1.178,-2.617 2.628,-2.617 h 74.469 c 1.445,0 2.629,1.174 2.629,2.617 0,1.469 -1.183,2.641 -2.629,2.641 z"
          id="path3773" inkscape:connector-curvature="0" style="fill:#284566" [ngStyle]="{'fill': darkcolor}" />
      </g>
    </g>
  </g>
  <g id="Calque_2" transform="translate(-238.077,-404.399)">
    <g id="g3784">
      <path d="m 250.199,453.438 c 0,2.137 1.751,3.889 3.878,3.889 h 84.552 c 2.131,0 3.883,-1.752 3.883,-3.889 l 9.684,-41.906 h -110.65 z"
        id="path3780" inkscape:connector-curvature="0" style="fill:#5c92cd" [ngStyle]="{'fill': lightcolor}" />
      <path d="M 354.076,404.399 H 239.935 c -1.053,0 -1.858,0.483 -1.858,1.085 v 4.952 c 0,0.612 0.806,1.096 1.858,1.096 h 1.611 110.649 1.881 c 1.004,0 1.811,-0.483 1.811,-1.096 v -4.952 c 0,-0.602 -0.807,-1.085 -1.811,-1.085 z"
        id="path3782" inkscape:connector-curvature="0" style="fill:#284566" [ngStyle]="{'fill': darkcolor}" />
    </g>
    <rect x="256.28699" y="407.39099" width="5.1989999" height="10.57" id="rect3786" style="fill:#ffffff" />
    <rect x="333.13699" y="407.39099" width="5.1989999" height="10.57" id="rect3788" style="fill:#ffffff" />
  </g>
</svg>
